import { createContext, useContext } from "react";

import { TemplateInfo } from "@fartherfinance/frontend/api/TaskWorkflows/Types";

import { TemplateTransition } from "./types";

export interface TemplateContextValue {
  currentTemplate: TemplateInfo | null;
  templateTransition: TemplateTransition;
  isLoadingTemplate: boolean;
  templateError: boolean;
  switchTemplate?: (taskTypeValue: unknown) => void;
}

export const TemplateContext = createContext<TemplateContextValue | null>(null);

export const useTemplateContext = (): TemplateContextValue => {
  const context = useContext(TemplateContext);
  if (!context) {
    throw new Error(
      "useTemplateContext must be used within a FormEngineProvider"
    );
  }
  return context;
};
